export default __webpack_public_path__ + "static/media/2.14e7bd66.png";